<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    @md-opened="openDialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
    class="md-medium-size-100 md-xsmall-size-100 md-size-100"
  >
    <md-dialog-title>Login Attempts</md-dialog-title>
    <md-dialog-content class="user-agent">
      <md-table v-model="loginAttempts" table-header-color="purple" md-card>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <slot v-if="slots.failureAttempts" name="failureAttempts" v-bind:item="item" />
          <template v-else>
            <md-table-cell md-label="Attempt time">{{ item.attemptTime | formatLoginAttemptTime }}</md-table-cell>
            <md-table-cell md-label="IP address">
              <div class="cells-with-icon">
                {{ item.ipAddress }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="User agent" class="user-agent">
              {{ item.userAgent | formatUserAgent }}
              <md-tooltip md-direction="top" class="user-agent-tooltip">{{ item.userAgent }}</md-tooltip>
            </md-table-cell>
          </template>
        </md-table-row>
      </md-table>
      <div class="md-layout-item md-size-100 text-right">
        <md-button @click="closeDialog">Close</md-button>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import moment from "moment";
import { ref, useSlots } from "@vue/composition-api";
import apiManager from "@/api-manager";
import snakeCaseObjectKeysToCamelCase from "@/utils/snakeCaseObjectKeysToCamelCase";

export default {
  name: "LoginAttempts",
  props: ["show", "attempts"],
  filters: {
    formatTime(value) {
      if (!value) return "";
      return moment(value).format("MMMM Do YYYY, h:mm:ss a"); // April 3rd 2021, 5:23:32 am
    },
    formatUserAgent(value) {
      return value.length > 30 ? value.slice(0, 30).concat("...") : value;
    },
  },
  setup(props, { emit }) {
    const slots = useSlots();
    const loginAttempts = ref([]);
    const getLoginAttempts = async () => {
      if (props.attempts) {
        loginAttempts.value = props.attempts;
      } else {
        const response = await apiManager.whoAmI();
        loginAttempts.value = snakeCaseObjectKeysToCamelCase(response.parsedData.attempts);
      }
    };
    const closeDialog = () => {
      emit("close");
    };
    const openDialog = async () => {
      await getLoginAttempts();
    };

    return {
      loginAttempts,
      getLoginAttempts,
      closeDialog,
      openDialog,
      slots,
    };
  },
};
</script>

<style scoped>
.user-agent {
  text-align: left !important;
}

.user-agent-tooltip {
  max-width: 60vw;
  width: fit-content;
  text-wrap: normal;
}

.cells-with-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
